import { useDesignMaxTheme } from "@/packages";
import { type RefundDmaxInfoResponse } from "@/shared/server";
import { Center, Td, Text, Th, Tr } from "@chakra-ui/react";
import { CustomTable, CustomTitle } from "./refund.style";

export const Refund = ({ refunds, section = true }: { refunds: RefundDmaxInfoResponse; section?: boolean }) => {
    const { MEDIAS } = useDesignMaxTheme();
    const { isTablet, isMobile } = MEDIAS();

    const { refund } = { ...refunds };
    const EMPTY_GROUP = Array.from({ length: 2 });

    const convertRefundToArray = (refund: { [key: string]: string }) => {
        return Object.entries(refund).map(([key, value]) => {
            const day = Number(key.replace("day_", ""));
            return {
                beforeDate: day === 0 ? "당일" : String(day),
                refund: value,
            };
        });
    };

    const refundArray = convertRefundToArray(refund);
    return (
        <Center
            as={section ? "section" : "div"}
            p={isMobile ? "40px 20px" : "120px 20px"}
            flexDir="column"
            rowGap={isTablet ? "32px" : "64px"}
        >
            <Center flexDir="column">
                <CustomTitle fontFamily="Cormorant">Pension Refund</CustomTitle>
                <Text fontFamily="Cormorant">환불 규정</Text>
            </Center>
            <Center w="100%" overflow={isTablet ? "auto" : ""} justifyContent={isTablet ? "flex-start" : "center"}>
                <CustomTable>
                    {EMPTY_GROUP.flatMap((_, trIdx) => (
                        <Tr>
                            {trIdx === 0 &&
                                refundArray?.map((refund, idx) => (
                                    <Th key={`${refund.beforeDate}-0as`}>
                                        {idx === 0 ? "당일 숙박" : `숙박 ${refund.beforeDate}일전`}
                                    </Th>
                                ))}
                            {trIdx === 1 &&
                                refundArray?.map((refund) => (
                                    <Td key={`${refund.beforeDate}-1as`}>{refund.refund}% 환불</Td>
                                ))}
                        </Tr>
                    ))}
                </CustomTable>
            </Center>
        </Center>
    );
};
